var _rect, _rect2, _g, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarnew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1216_243390)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#C1D5FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1216_243390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#2E2E2E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1216_243390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 11.2C11.2498 11.2 10.6125 10.9374 10.0878 10.412C9.56247 9.88738 9.2998 9.25005 9.2998 8.50005C9.2998 7.75005 9.56247 7.11272 10.0878 6.58805C10.6125 6.06272 11.2498 5.80005 11.9998 5.80005C12.7498 5.80005 13.3875 6.06272 13.9128 6.58805C14.4375 7.11272 14.6998 7.75005 14.6998 8.50005C14.6998 9.25005 14.4375 9.88738 13.9128 10.412C13.3875 10.9374 12.7498 11.2 11.9998 11.2ZM17.9498 18.2H6.0498C5.83314 18.2 5.65414 18.129 5.5128 17.987C5.3708 17.8457 5.2998 17.6667 5.2998 17.45V16.9C5.2998 16.5334 5.41247 16.1877 5.6378 15.863C5.86247 15.5377 6.16647 15.2834 6.5498 15.1C7.46647 14.6667 8.37914 14.3417 9.2878 14.125C10.1958 13.9084 11.0998 13.8 11.9998 13.8C12.8998 13.8 13.8041 13.9084 14.7128 14.125C15.6208 14.3417 16.5331 14.6667 17.4498 15.1C17.8331 15.2834 18.1375 15.5377 18.3628 15.863C18.5875 16.1877 18.6998 16.5334 18.6998 16.9V17.45C18.6998 17.6667 18.6291 17.8457 18.4878 17.987C18.3458 18.129 18.1665 18.2 17.9498 18.2ZM5.9998 17.5H17.9998V16.9C17.9998 16.6667 17.9208 16.446 17.7628 16.238C17.6041 16.0294 17.3831 15.85 17.0998 15.7C16.2998 15.3167 15.4708 15.0207 14.6128 14.812C13.7541 14.604 12.8831 14.5 11.9998 14.5C11.1165 14.5 10.2455 14.604 9.3868 14.812C8.5288 15.0207 7.6998 15.3167 6.8998 15.7C6.61647 15.85 6.3958 16.0294 6.2378 16.238C6.07914 16.446 5.9998 16.6667 5.9998 16.9V17.5ZM11.9998 10.5C12.5498 10.5 13.0208 10.304 13.4128 9.91205C13.8041 9.52071 13.9998 9.05005 13.9998 8.50005C13.9998 7.95005 13.8041 7.47938 13.4128 7.08805C13.0208 6.69605 12.5498 6.50005 11.9998 6.50005C11.4498 6.50005 10.9791 6.69605 10.5878 7.08805C10.1958 7.47938 9.9998 7.95005 9.9998 8.50005C9.9998 9.05005 10.1958 9.52071 10.5878 9.91205C10.9791 10.304 11.4498 10.5 11.9998 10.5Z",
    fill: "#3676F5"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1216_243390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarnew);
export default __webpack_public_path__ + "static/media/avatarnew.8f767b3ddd5f93f1494354f32b72fb0f.svg";
export { ForwardRef as ReactComponent };